const TOKEN_KEY = 'accessToken';

let cachedToken: string | null = null;

export function getAccessToken(): string | null {
    if (cachedToken) return cachedToken;

    try {
        const storedLocal = localStorage.getItem(TOKEN_KEY);
        if (storedLocal) {
            cachedToken = storedLocal;
            return cachedToken;
        }

        const storedSession = sessionStorage.getItem(TOKEN_KEY);
        if (storedSession) {
            cachedToken = storedSession;
            return cachedToken;
        }

        return null;
    } catch {
        return null;
    }
}

export function setAccessToken(token: string, rememberMe?: boolean): void {
    let useSession = false;

    try {
        useSession =
            rememberMe === false ||
            (rememberMe === undefined && !!sessionStorage.getItem(TOKEN_KEY));
    } catch {
        // Ignore errors accessing storage
    }

    // Always clear existing tokens to prevent stale states or inconsistencies
    clearAccessToken();

    cachedToken = token;
    try {
        if (useSession) {
            sessionStorage.setItem(TOKEN_KEY, token);
        } else {
            localStorage.setItem(TOKEN_KEY, token);
        }
    } catch {
        // storage unavailable — token lives in memory only
    }
}

export function clearAccessToken(): void {
    cachedToken = null;
    try {
        localStorage.removeItem(TOKEN_KEY);
        sessionStorage.removeItem(TOKEN_KEY);
    } catch {
        // noop
    }
}
